import { useState, useEffect, useRef } from "react";
import { firestore } from "./firebase/firebase";
import { useAuth } from "./firebase/AuthContext";
import {
  Modal,
  Backdrop,
  Fade,
  IconButton,
  FormControl,
  InputLabel,
  Input,
  Button
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import PlansScreen from "./paymentModel";
import CloseIcon from '@mui/icons-material/Close';

import { Link, useHistory } from "react-router-dom";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

const useStyles = makeStyles(theme => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "scroll"

    },
    paper: {
      backgroundColor: "#fff",
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      textAlign: "center",
      width: '400px',
    },
    form: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    rounded: {
      borderRadius: "10px",
      border: "none",
    },
  }));

function Settings() {
  const [isOpen, setIsOpen] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const classes = useStyles();

  const emailRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { currentUser, updatePassword, updateEmail } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();



  function handleSubmit(e) {
    e.preventDefault();
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    const promises = [];
    setLoading(true);
    setError("");

    if (emailRef.current.value !== currentUser.email) {
      promises.push(updateEmail(emailRef.current.value));
    }
    if (passwordRef.current.value) {
      promises.push(updatePassword(passwordRef.current.value));
    }

    Promise.all(promises)
      .then(() => {
        handleClose();
      })
      .catch(() => {
        setError("Failed to update account");
        toast.error("Opps, something went wrong.", {
          position: toast.POSITION.TOP_CENTER
      })
      })
      .finally(() => {
        setLoading(false);
        toast.success("Your credentials have been updated!", {
          position: toast.POSITION.TOP_CENTER
      })
      });
  };

  //This allows users to see their total suggestions and summaries
  useEffect(() => {
    if (isOpen) {
      firestore
        .collection("customers")
        .doc(currentUser.uid)
        .collection("subscriptions")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach(async (subscriptionDoc) => {
            //console.log(subscriptionDoc.data()); // Add this line to check the data
            setSubscription({
              id: subscriptionDoc.id,
              suggestions:
                subscriptionDoc.data().items[0].price.product.metadata
                  .Suggestions,
              summaries:
                subscriptionDoc.data().items[0].price.product.metadata.Summaries,
              status: subscriptionDoc.data().status
            });
          });
        })
        .catch((error) => {
          console.log("Error getting subscriptions: ", error);
        });
    }
  }, [isOpen, currentUser.uid]);


  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <ManageAccountsIcon />
      </IconButton>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isOpen} // Fixed variable name from "open" to "isOpen"
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={isOpen}>
        <div style={{ backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0px 3px 20px rgba(0,0,0,0.1)', padding: '30px', maxWidth: '400px', width: '100%', outline:'none', textAlign:'center' }}>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
  <IconButton onClick={handleClose}>
    <CloseIcon />
  </IconButton>
</div>
          <h2 id="transition-modal-title">Settings</h2>
            {subscription === null || subscription.status === 'canceled' ? null : (
  <div style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', padding: '20px', marginBottom: '20px', borderRadius:'10px' }} >
      <h3>Remaining</h3>
      <div >
      <h4>Summaries: {subscription.summaries} / 250</h4>
    </div>
    <div >
    <h4>Suggestions: {subscription.suggestions} / 1000</h4>
    </div>
  </div>
)}
{error && <h5 style={{color: 'red'}}>{error}</h5>}
        <form style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={handleSubmit}>
          <FormControl>
            <InputLabel htmlFor="email">Email</InputLabel>
            <Input
              type="email"
              id="email"
              inputRef={emailRef}
              defaultValue={currentUser.email}
              required
              sx={{
                "& fieldset": {
                  border: "none",
                }
              }}
              inputProps={{
                style: {
                  fontFamily: "'inter",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "20px",
                  color: `grey`,
                  margin: '5px',
                  textAlign: "left",
                  "&::placeholder": {
                    textAlign: "left"
                  }
                }
              }}
            />
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              type="password"
              id="password"
              inputRef={passwordRef}
              placeholder="Leave blank to keep the same"
              required
              sx={{
                "& fieldset": {
                  border: "none",
                }
              }}
              inputProps={{
                style: {
                  fontFamily: "'inter",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "20px",
                  color: `grey`,
                  margin: '5px',
                  textAlign: "left",
                  "&::placeholder": {
                    textAlign: "left"
                  }
                }
              }}
            />
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="password-confirm">Password Confirm</InputLabel>
            <Input
              type="password"
              id="password-confirm"
              inputRef={passwordConfirmRef}
              placeholder="Leave blank to keep the same"
              required
              sx={{
                "& fieldset": {
                  border: "none",
                }
              }}
              inputProps={{
                style: {
                  fontFamily: "'inter",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "20px",
                  color: `grey`,
                  margin: '5px',
                  textAlign: "left",
                  "&::placeholder": {
                    textAlign: "left"
                  }
                }
              }}
            />
          </FormControl>
          <Button style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', marginTop: '40px' }} disabled={loading} type="submit">
            Update Profile
          </Button>
        </form>
            <PlansScreen />
          </div>
        </Fade>
      </Modal>
    </>
  );
  
  
      
  }
  
  export default Settings;